import React, { useEffect, useRef, useState } from "react";
import DataTable from "react-data-table-component";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  ADMIN_DETAILS,
  ADD_CONSERVATION,
  EDIT_OBJECT,
  EDIT_PHOTOGRAPHY,
  LIST_OBJECT,
  HOME_URL,
} from "../../constants/routers";
import { CiEdit } from "react-icons/ci";
import { RiDeleteBin6Line } from "react-icons/ri";
import Tooltip from "@mui/material/Tooltip";
import { IoEye } from "react-icons/io5";
import star from "../../assets/images/category/star.png";
import dummyImage from "../../assets/images/common/nefos.png";
import Modal from "react-bootstrap/Modal";
import Loader from "../../components/common/Common/Loader";
import {
  assignUser,
  createGlb,
  createObject,
  createPhotography,
  DeleteObject,
  objectConservationCreation,
  objectConservationStatus,
  objectTableEditHandler,
} from "../../api/actions/object";
import toast from "react-hot-toast";
import dummyPro from "../../assets/images/common/profile-logo.png";
import { RiVipCrownFill } from "react-icons/ri";
import { checkPermission } from "../../helpers/permissions";
import { localDataStore } from "../../components/common/Common/localDataStore";
import Select from "react-select";
import Drawer from "react-modern-drawer";
import ObjectAdd from "./objectAdd";
import {
  clearAutoSavedFromIndexedDB,
  getAutoSavedFromIndexedDB,
} from "../../indexdb/autosaveIndex";
import { useSaving } from "../../store/SavinContext";
import Objectconsadd from "../ObjectConservation/objectconsadd";
import Objectphotographydetails from "../objectPhotography/Objectphotographydetails";
import { saveModuleState } from "../../indexdb/scrollFreezeIndex";
import { RxOpenInNewWindow } from "react-icons/rx";
import "../../assets/styles/component-styles/dataTable.scss";
import { autoSaveDraftIfExists } from "../../components/common/Common/utils/AutosaveDraft";
import OverRideAlert from "../../components/common/sweetAlert/overRideAlert";
import {
  overRideCancelHandlerAutosave,
  overRideConfirmHandlerAutosave,
} from "../../components/common/Common/utils/overRideConfirmHandlerAutosave";
import Objectadmindetails from "./Objectadmindetails";
const ObjectTable = ({
  stateObj,
  encodedState,
  encodedStateDigital,
  count,
  objectDigitalFilterData,
  setJustSearched,
  justSearched,
  setReachBottom,
  reachBottom,
  setShowLoader,
  showLoader,
  scrollComplete,
  setScrollComplete,
  fetchObjectList,
  hasMore,
  setData,
  search,
  selectedContents,
  formik,
  setOrder,
  order,
  sortBy,
  setSortBy,
  admin,
  conservation = false,
  photography = false,
  setSelectedOption,
  selectedOption,
  checkedRowHandler,
  page,
  showGrid,
  showTable,
  setShowGrid,
  setShowTable,
  data,
  setPage,
  limit,
  setLimit,
  update,
  setUpdate,
  totalRows,
  pending,
  selectProps,
  lastPageData,
  handleRowSelected,
  isSwal,
  setIsSwal,
  setSelectedRows,
  handleSerialNumber,
}) => {
  const [showDate, setShowDate] = useState();
  const [driveChange, setDriveChange] = useState(null);
  const [conditionChange, setConditionChange] = useState(null);
  const [isAutoObjectList, setIsAutoObjectList] = useState(false);
  const navigate = useNavigate();
  const scrollabletableRef = useRef();
  const [selectedScrollTop, setSelectedScrollTop] = useState();

  const deleteHandler = (deleteId) => {
    DeleteObject({ id: [deleteId] })((response) => {
      if (response?.status) {
        toast.success("Object deleted successfully");
        setUpdate(!update);
      }
    });
  };
  const [showObjectdetail, setShowObjectDetail] = useState({
    show: false,
    id: "",
    collection: false,
    digital: false,
    conservation: false,
    adminDetail: false,
  });
  const [showDetail, setShowDetail] = useState(false);
  const [details, setDetails] = useState();
  const [detailImage, setDetailImage] = React.useState();
  const [detaildescr, setDetaildescr] = React.useState();
  const [onMobileView, setOnMobileView] = React.useState(false);
  const [savedDataFromIndex, setSavedDataFromIndex] = useState({
    collection: null,
    digital: null,
    conservation: null,
  });
  const [autoSaveError, setAutoSaveError] = useState(false); // ← track autosave error

  const userData = JSON.parse(localStorage.getItem("user_info"));
  const location = useLocation();
  const MODULE_KEY = "object_list";
  const { setIsSaving } = useSaving();

  const queueDatatableCustomStyles = {
    style: {
      borderRadius: "8px",
    },
    headCells: {
      style: {
        backgroundColor: "#D7E2F3",
        color: "#000000",

        fontWeight: "600",
        fontSize: "14px",
        paddingLeft: "15px",
      },
    },
    cells: {
      style: {
        fontSize: "12px",
        fontWeight: "500",
        paddingTop: "12px",
        paddingBottom: "12px",
        paddingLeft: "10px",
      },
    },
  };

  const showHandler = (value, e) => {
    setShowDate(value?.created_date);
    setShowDetail(true);
    setDetailImage(value?.reference_image);
    setDetaildescr(value?.historical_description);
    setDetails(value);
  };

  const onclicktoStorage = async () => {
    await saveModuleState(MODULE_KEY, {
      scrollY: selectedScrollTop,
      selectedPage: page,
      selectedData: data,
      selectedOption: selectedOption,
      count: count,
      fromTable: true,
      hasMore: hasMore,
      reachBottom: reachBottom,
      filterCount: photography ? count : totalRows,
    });
  };

  const hideHandler = () => {
    setShowDetail(false);
  };

  const onEditRedirectHandler = (row) => {
    onclicktoStorage();
    localDataStore(
      search,
      selectedContents,
      formik,
      true,
      (conservation && "conservation") ||
        (location.pathname.split("/")[2] === LIST_OBJECT && "collection") ||
        (photography && "digital") ||
        "admin"
    );

    navigate(
      `/${
        userData.museum_name
          ? userData?.museum_name?.split(" ").join("_")
          : "Nefos"
      }/${
        (photography &&
          checkPermission(["photogrophy_change_object"]) &&
          EDIT_PHOTOGRAPHY) ||
        (conservation &&
          checkPermission(["conservation_change_object"]) &&
          ADD_CONSERVATION) ||
        (checkPermission(["collection_change_object"]) &&
          location.pathname.split("/")[2] === LIST_OBJECT &&
          EDIT_OBJECT) ||
        ADMIN_DETAILS
      }/${row?.id}`,
      {
        state: {
          objectListFormik: photography ? objectDigitalFilterData : stateObj,
          fromObjectTable: true,
        },
      }
    );
  };

  const onBlurHandler = (rowIndex, row, type) => {
    if (type === "condition") {
      setData((prevData) =>
        prevData.map((item) => ({
          ...item,
          is_edit_condition: false,
        }))
      );
      if (conditionChange) {
        objectTableEditHandler(conditionChange)((response) => {
          if (response?.status) {
            setDriveChange(null);
          }
        });
      }
    } else {
      setData((prevData) =>
        prevData.map((item) => ({
          ...item,
          is_edit_drive: false,
        }))
      );
      if (driveChange) {
        objectTableEditHandler(driveChange)((response) => {
          if (response?.status) {
            setDriveChange(null);
          }
        });
      }
    }
  };

  const doubleClickHandler = (e, rowIndex, type) => {
    const newUpdateList = [...data];

    if (type === "Condition") {
      newUpdateList[rowIndex].is_edit_condition = true;
      setData(newUpdateList);
    } else {
      newUpdateList[rowIndex].is_edit_drive = true;
      setData(newUpdateList);
    }
  };

  const onConditionChangeHandler = (e, rowIndex, row) => {
    const dataList = [...data];

    if (e?.label === "Emergency") {
      dataList[rowIndex].is_emergency = true;
      dataList[rowIndex].stability = "";
      setData(dataList);
      const driveData = {
        id: row?.id,
        is_emergency: true,
        stability: "",
      };
      setConditionChange(driveData);
    } else {
      dataList[rowIndex].stability = e?.label;
      dataList[rowIndex].is_emergency = false;
      setData(dataList);
      const driveData = {
        id: row?.id,
        stability: e?.label,
        is_emergency: false,
      };
      setConditionChange(driveData);
    }
  };

  const canPhotography =
    photography && checkPermission(["photogrophy_change_object"]);

  const canConservation =
    conservation && checkPermission(["conservation_change_object"]);

  const canCollection =
    location.pathname.split("/")[2] === LIST_OBJECT &&
    checkPermission(["collection_change_object"]);

  const canAdmin = admin;

  const canOpen =
    canPhotography || canConservation || canCollection || canAdmin;

  const columns = [
    {
      name: "Object ",
      key: "object_name",
      selector: (row) => row?.object_name,
      cell: (row) => (
        <div style={{ position: "relative", width: "100%" }}>
          <div className="category-name" style={{ cursor: "pointer" }}>
            <div
              onClick={() => {
                if (onMobileView) {
                  onEditRedirectHandler(row);
                } else {
                  if (
                    location.pathname.split("/")[2] === LIST_OBJECT &&
                    checkPermission(["collection_change_object"])
                  ) {
                    setShowObjectDetail({
                      id: row?.id,
                      show: true,
                      collection: true,
                    });
                  } else if (
                    photography &&
                    checkPermission(["photogrophy_change_object"])
                  ) {
                    setShowObjectDetail({
                      id: row?.id,
                      show: true,
                      digital: true,
                    });
                  } else if (
                    location.pathname.split("/")[2] === "list-conservation" &&
                    checkPermission(["conservation_change_object"])
                  ) {
                    setShowObjectDetail({
                      id: row?.id,
                      show: true,
                      conservation: true,
                    });
                  } else if (admin) {
                    localDataStore(
                      search,
                      selectedContents,
                      formik,
                      true,
                      (conservation && "conservation") ||
                        (location.pathname.split("/")[2] === LIST_OBJECT &&
                          "collection") ||
                        (photography && "digital") ||
                        "admin"
                    );
                    navigate(
                      `/${
                        userData.museum_name
                          ? userData?.museum_name?.split(" ").join("_")
                          : "Nefos"
                      }/${ADMIN_DETAILS}/${row?.id}`
                    );
                  } else {
                    setShowObjectDetail({
                      id: row?.id,
                      show: true,
                      adminDetail: true,
                    });
                  }
                }
              }}
              className="d-flex align-items-center"
            >
              <div className="star-img">
                {" "}
                {row?.iconic_object && (
                  <RiVipCrownFill color="gold" style={{ fontSize: "17px" }} />
                )}
              </div>

              {row?.reference_image ? (
                <img
                  className={row?.reference_image ? "thumb-img" : "error-img"}
                  src={row?.reference_image}
                  onError={(e) => (e.currentTarget.src = dummyImage)}
                  alt="ref-img"
                />
              ) : (
                <img className="error-img" src={dummyImage} alt="ref-img" />
              )}
              <div>
                <p style={{ maxWidth: "286px" }}>{row?.object_name}</p>
                <span style={{ color: "gray", fontSize: "12px" }}>
                  {row?.accession_number}
                </span>
              </div>
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              {canOpen && (
                <a
                  href={`/${
                    userData.museum_name
                      ? userData?.museum_name?.split(" ").join("_")
                      : "Nefos"
                  }/${
                    (photography &&
                      checkPermission(["photogrophy_change_object"]) &&
                      EDIT_PHOTOGRAPHY) ||
                    (conservation &&
                      checkPermission(["conservation_change_object"]) &&
                      ADD_CONSERVATION) ||
                    (checkPermission(["collection_change_object"]) &&
                      location.pathname.split("/")[2] === LIST_OBJECT &&
                      EDIT_OBJECT) ||
                    ADMIN_DETAILS
                  }/${row?.id}?state=${
                    photography ? encodedStateDigital : encodedState
                  }`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="kanban-link"
                  style={{ top: "0", right: "0" }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <Tooltip style={{ zIndex: 0 }} title="Open object in new tab">
                    <span style={{ display: "flex" }}>
                      <RxOpenInNewWindow style={{ fontSize: "13px" }} />
                    </span>
                  </Tooltip>
                </a>
              )}
            </div>
          </div>
        </div>
      ),
      sortable: true,
      grow: 2,
      minWidth: "410px",
      paddingLeft: "15px",
      reorder: false,
    },
    {
      name: "Category",
      key: "category__category_name",
      selector: (row) => row?.category_name,
      cell: (row) => {
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            <div className="star-img" style={{ width: "28px" }}>
              {" "}
              {row?.key_category === "True" && (
                <img
                  style={{ height: "18px" }}
                  src={star}
                  className="me-2"
                  alt="crown"
                />
              )}
            </div>

            <p>
              {row.prime_category_name && row.category_name
                ? `${row.prime_category_name}-${row.category_name}`
                : row.prime_category_name || row.category_name || ""}
            </p>
          </div>
        );
      },
      sortable: true,
      minWidth: "180px",
    },
    {
      name: "Material",
      key: "material__material_name",
      selector: (row) => row?.material_name,
      cell: (row) => (
        <div style={{ display: "flex" }}>
          <div>
            {row?.material?.slice(0, 2)?.map((li, index, arr) => (
              <p key={index}>
                {li?.material_name}
                {index !== arr.length - 1 && ","}
              </p>
            ))}
          </div>
          {row?.material?.length > 2 && (
            <span
              onClick={() => onEditRedirectHandler(row)}
              style={{
                display: "flex",
                alignItems: "flex-end",
                color: "blue",
                cursor: "pointer",
                fontSize: "11px",
                marginLeft: "2px",
              }}
            >{`+${row?.material?.length - 2}`}</span>
          )}
        </div>
      ),
      sortable: true,
      minWidth: "180px",
    },
    {
      name: "Condition grade",
      key: "priority",
      selector: (row) => row?.is_emergency || row?.stability,
      cell: (row, rowIndex) => (
        <div
          style={{
            width: "100%",
            height: "100%",
            cursor: "text",
            display: "flex",
          }}
        >
          <div
            onDoubleClick={(e) => doubleClickHandler(e, rowIndex, "Condition")}
            style={{
              width: "100%",
              height: "100%",
              cursor: "text",
              display: "flex",
            }}
          >
            {checkPermission(["conservation_change_object"]) ? (
              row?.is_edit_condition ? (
                <Select
                  styles={{
                    container: (styles) => ({
                      ...styles,
                      width: "100%",
                    }),
                  }}
                  onBlur={() => onBlurHandler(rowIndex, row, "condition")}
                  onChange={(e) => onConditionChangeHandler(e, rowIndex, row)}
                  options={[
                    {
                      value: 1,
                      label: 1,
                    },
                    {
                      value: 2,
                      label: 2,
                    },
                    {
                      value: 3,
                      label: 3,
                    },
                    {
                      value: "Emergency",
                      label: "Emergency",
                    },
                  ]}
                  value={{
                    value: row?.stability
                      ? row?.stability
                      : row?.is_emergency
                      ? "Emergency"
                      : "",
                    label: row?.stability
                      ? row?.stability
                      : row?.is_emergency
                      ? "Emergency"
                      : "",
                  }}
                />
              ) : (
                <Tooltip title="Double click to edit" placement="top-end">
                  <p style={{ width: "100%", height: "100%" }}>
                    {row?.stability
                      ? row?.stability
                      : row?.is_emergency
                      ? "Emergency"
                      : ""}
                  </p>
                </Tooltip>
              )
            ) : (
              <p style={{ width: "100%", height: "100%" }}>
                {row?.stability
                  ? row?.stability
                  : row?.is_emergency
                  ? "Emergency"
                  : ""}
              </p>
            )}
          </div>
        </div>
      ),
      sortable: true,
      minWidth: "180px",
      omit: !conservation,
    },
    {
      name: "Created by",
      key: "created_by__first_name",
      selector: (row) => (row.created_by_name ? row.created_by_name : "Admin"),
      cell: (row) => (
        <div className="created-box">
          <img
            className={row.created_by_thumbnail ? "image" : "error-img"}
            src={row.created_by_thumbnail ? row.created_by_thumbnail : dummyPro}
            alt="dummy-pro"
          />
          {row.created_by_name ? row.created_by_name : "Admin"}
        </div>
      ),
      sortable: true,
      grow: 2,
      width: "180px",
      reorder: false,
    },
    {
      name: "Created at",
      key: "",
      selector: (row) => row?.created_date,
      cell: (row) => {
        return (
          <div className="date-cell">
            <p>{row?.created_date}</p>
          </div>
        );
      },
      sortable: true,
      grow: 2,
      width: "180px",
      reorder: false,
    },
    {
      name: "Updated by",
      key: "modified_by_first_name",
      selector: (row) =>
        row.modified_by_first_name ? row.modified_by_first_name : "Admin",
      cell: (row) => (
        <div className="created-box">
          <img
            className={row.modified_by_thumbnail ? "image" : "error-img"}
            src={
              row.modified_by_thumbnail ? row.modified_by_thumbnail : dummyPro
            }
            alt="dummy-pro"
          />
          {row.modified_by_first_name ? row.modified_by_first_name : "Admin"}
        </div>
      ),
      sortable: true,
      grow: 2,
      width: "180px",
      reorder: false,
    },
    {
      name: "Last updated",
      key: "modified_date",
      selector: (row) => row?.modified_date,
      cell: (row) => {
        return (
          <div className="date-cell">
            <p>{row?.modified_date}</p>
          </div>
        );
      },
      sortable: true,
      grow: 2,
      width: "180px",
      reorder: false,
    },

    {
      name:
        location.pathname.split("/")[2] === "dashboard" ? "Action" : "Actions",
      key: "action",
      cell: (row, deleteIndex) => (
        <div className="action-wrapper">
          <Tooltip title="View">
            <div className="eye-wrapper" onClick={() => showHandler(row)}>
              <IoEye />
            </div>
          </Tooltip>

          {((checkPermission(["collection_change_object"]) &&
            location.pathname.split("/")[2] === LIST_OBJECT) ||
            (checkPermission(["photogrophy_change_object"]) && photography) ||
            (checkPermission(["conservation_change_object"]) &&
              conservation)) && (
            <Tooltip title="Edit" onClick={() => onEditRedirectHandler(row)}>
              <div className="eye-wrapper">
                <CiEdit />
              </div>
            </Tooltip>
          )}
        </div>
      ),
      grow: 0.1,
      minWidth: "130px",
    },
  ];

  const handleSort = (column, sortDirection) => {
    setOrder((prevOrder) => (prevOrder === "desc" ? "asc" : "desc"));
    setSortBy(column?.key);
    setUpdate(!update);
  };

  useEffect(() => {
    // const timeout = setTimeout(() => {
    const scrollContainer = document.querySelector(".my-data-table");

    if (justSearched) {
      scrollContainer.scrollTop = 0;
    }

    const handleScroll = () => {
      if (!scrollContainer || justSearched) return;

      const { scrollTop, scrollHeight, clientHeight } = scrollContainer;

      setSelectedScrollTop(scrollTop);

      if (scrollTop + clientHeight >= scrollHeight - 50) {
        console.log("Reached bottom of DataTable!");
        setReachBottom(true);
        // setScrollComplete(true);
        // setShowLoader(true)
        setJustSearched(false);
        fetchObjectList("next");

        // Remove the scroll listener after reaching bottom
        scrollContainer.removeEventListener("scroll", handleScroll);
      }
    };

    if (scrollContainer && hasMore && !reachBottom) {
      scrollContainer.addEventListener("scroll", handleScroll);
    }

    // Cleanup function
    return () => {
      if (scrollContainer) {
        scrollContainer.removeEventListener("scroll", handleScroll);
      }
    };
    // }, 300);

    // return () => clearTimeout(timeout);
  }, [hasMore, reachBottom, justSearched]);

  const onCloseObject = () => {
    setIsAutoObjectList(true);

    autoSaveDraftIfExists(
      setIsSaving,
      userData,
      setAutoSaveError,
      setSavedDataFromIndex
    );
    setShowObjectDetail({
      id: "",
      show: false,
    });
  };

  useEffect(() => {
    const handleScroll = () => {
      const width = window.innerWidth;
      if (width < 620) {
        setOnMobileView(true);
      } else {
        setOnMobileView(false);
      }
    };

    handleScroll(); // set initial state on page load
    window.addEventListener("resize", handleScroll);

    return () => window.removeEventListener("resize", handleScroll);
  }, []);
  return (
    <div>
      <div className="table-wrapp" style={{ width: "100%" }}>
        <Drawer
          open={showObjectdetail.show}
          onClose={() => onCloseObject()}
          direction="right"
          className="bla bla bla"
          style={{ width: "80%", overflowX: "hidden" }}
          enableOverlay={false}
          onWheel={(e) => {
            const el = e.currentTarget;
            const atTop = el.scrollTop === 0;
            const atBottom = el.scrollHeight - el.scrollTop === el.clientHeight;

            // prevent parent scroll if not at top or bottom
            if (!atTop && !atBottom) {
              e.stopPropagation();
            }
          }}
        >
          {showObjectdetail.collection && (
            <ObjectAdd
              isAutoObjectList={isAutoObjectList}
              onCloseObject={onCloseObject}
              objectId={showObjectdetail.id}
              fromList={showObjectdetail.show}
            />
          )}
          {showObjectdetail.digital && (
            <Objectphotographydetails
              onCloseObject={onCloseObject}
              objectId={showObjectdetail.id}
              fromList={showObjectdetail.show}
            />
          )}
          {showObjectdetail.conservation && (
            <Objectconsadd
              onCloseObject={onCloseObject}
              objectId={showObjectdetail.id}
              fromList={showObjectdetail.show}
            />
          )}
          {showObjectdetail.adminDetail && (
            <Objectadmindetails
              onCloseObject={onCloseObject}
              objectId={showObjectdetail.id}
              fromList={showObjectdetail.show}
            />
          )}
        </Drawer>
        <Modal size="xl" show={showDetail} onHide={hideHandler}>
          <Modal.Header className="detail-view-header" closeButton>
            <Modal.Title
              style={{
                maxWidth: "440px",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {details?.object_name}
            </Modal.Title>
            {((checkPermission(["collection_change_object"]) &&
              location.pathname.split("/")[2] === LIST_OBJECT) ||
              (checkPermission(["photogrophy_change_object"]) && photography) ||
              (checkPermission(["conservation_change_object"]) &&
                conservation)) && (
              <Tooltip title="Edit">
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() => onEditRedirectHandler(details)}
                  className="eye-wrapper"
                >
                  {" "}
                  <CiEdit />
                </div>
              </Tooltip>
            )}
          </Modal.Header>
          <Modal.Body>
            <div className="detail-view-modal d-flex">
              <div className="detail-image">
                <div
                  style={{
                    height: "409px",
                    width: "300px",
                    border: detailImage
                      ? "1px solid rgb(238, 238, 238)"
                      : "none",
                    padding: "5px",
                    borderRadius: "5px",
                  }}
                >
                  <img
                    style={{
                      height: "100%",
                      width: "100%",
                      objectFit: "contain",
                    }}
                    className={detailImage ? "thumb-img" : "error-img"}
                    onError={(e) => (e.currentTarget.src = dummyImage)}
                    src={detailImage ? detailImage : dummyImage}
                    alt="detail-image"
                  />
                </div>
                <div className="create-card-object">
                  <div className="create-by">
                    <h6>Created by</h6>
                    <p>
                      {" "}
                      {details?.created_by_name
                        ? details?.created_by_name
                        : "Admin"}
                    </p>
                  </div>
                  <div className="create-at">
                    <h6>Created at</h6>
                    <p>{showDate}</p>
                  </div>
                </div>
              </div>
              <div className="detail-mid">
                <div className="detail-descr" style={{ height: "490px" }}>
                  <div className="descr-title">
                    <h5
                      style={{
                        maxWidth: "440px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {details?.object_name}
                    </h5>
                    {detaildescr && (
                      <p
                        style={{ overflow: "auto", height: "470px" }}
                        className="pl-5"
                      >
                        {detaildescr}
                      </p>
                    )}
                  </div>
                  {!detaildescr && (
                    <p
                      className="descr-not-found"
                      style={{ alignItems: "flex-start" }}
                    >
                      Description not added yet! Please tell us more...
                    </p>
                  )}
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <DataTable
          className="my-data-table"
          columns={columns}
          fixedHeaderScrollHeight="68vh"
          data={data}
          defaultSortAsc={
            conservation || admin || photography
              ? order === "asc"
                ? true
                : false
              : order === "desc"
              ? true
              : false
          }
          striped={true}
          center={true}
          highlightOnHover
          fixedHeader
          onSort={handleSort}
          sortServer
          selectableRowsComponentProps={selectProps}
          onSelectedRowsChange={checkedRowHandler}
          onChangePage={(page) => {
            setPage(page);
            setUpdate(!update);
          }}
          onChangeRowsPerPage={(perPage, pageNumber) => {
            setLimit(perPage);
            setUpdate(!update);
            setPage(pageNumber);
          }}
          progressPending={pending}
          progressComponent={<Loader />}
          customStyles={queueDatatableCustomStyles}
          conditionalRowStyles={[
            {
              when: (row) => row.id === showObjectdetail?.id,
              style: {
                backgroundColor: "#EEEEEE", // light blue highlight
                color: "black",
              },
            },
          ]}
        />
      </div>
      {reachBottom && (
        <div style={{ display: "flex", justifyContent: "center" }}>
          {!pending &&
            (hasMore ? (
              <p
                style={{ textAlign: "center", padding: "1rem", color: "gray" }}
              >
                <b>Loading more...</b>
              </p>
            ) : (
              reachBottom &&
              data?.length > 0 && (
                <p
                  style={{
                    textAlign: "center",
                    padding: "1rem",
                    color: "gray",
                  }}
                >
                  <b>You have seen it all</b>
                </p>
              )
            ))}
        </div>
      )}
      {autoSaveError && (
        <OverRideAlert
          fromAutosave={true}
          objectData={
            savedDataFromIndex.collection ||
            savedDataFromIndex.digital ||
            savedDataFromIndex?.conservation
          }
          fromLayout={true}
          overRideConfirmHandler={() =>
            overRideConfirmHandlerAutosave(
              savedDataFromIndex,
              setIsSaving,
              setAutoSaveError,
              setSavedDataFromIndex
            )
          }
          overRideCancel={() =>
            overRideCancelHandlerAutosave(
              savedDataFromIndex,
              setSavedDataFromIndex,
              setAutoSaveError
            )
          }
        />
      )}
    </div>
  );
};

export default ObjectTable;
